const locale = {
  TITLE: "دولة",
};

export default locale;
